import useFetchPromise from './useFetchPromise';
import whitelistsApi from '../api/whitelistsApi';

const useFetchBearsWhitelist = () =>
  useFetchPromise<[number, string][]>(whitelistsApi.fetchBearsWhitelist, true);

export default useFetchBearsWhitelist;
